import {throwError, AppActionType, Payload} from 'actions/Error';
import {ApiClientConfig, AppConfig} from 'host/types';

export function isValidConfig(appConfig: AppConfig, config: ApiClientConfig) {
  if (!appConfig) {
    return false;
  }

  const {apiKey} = appConfig;
  if (!apiKey || apiKey !== config.apiKey) {
    return false;
  }

  return true;
}

export function throwInvalidConfigError(
  appConfig: AppConfig,
  config: ApiClientConfig,
  action: Payload,
) {
  throwError(
    AppActionType.INVALID_CONFIG,
    action,
    `Provided apiKey \`${appConfig.apiKey}\` is incorrect. Expecting \`${config.apiKey}\``,
  );
}



// WEBPACK FOOTER //
// ./src/host/clientValidator.ts